<template>
  <div>
    <img alt="Vue logo" src="./assets/logo.png" height="50px;" />
    <nav>
      <RouterLink to="/">Dashboard</RouterLink>
      <RouterLink to="/configuration">Configuration</RouterLink>
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>